module.exports = __webpack_public_path__ + "static/media/total-saidas-icon.abf77348.svg";